import * as React from 'react'
import { AlertCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FormErrorProps {
  /** What went wrong. Nothing renders while this is empty. */
  children: React.ReactNode
  /** `sm` for a dense row or a narrow column, in the hint's size. */
  size?: 'default' | 'sm'
  id?: string
  className?: string
}

/**
 * What went wrong with something the person just did — a save that failed, a
 * request the server refused — under the form or beside the action. The same
 * treatment as a field's error (`Field`): danger ink with its icon, so an error
 * reads as one whether it belongs to a field or to the whole form, and it is
 * announced when it appears.
 *
 * A field's own message goes in `Field`'s `error`, not here.
 */
export function FormError({ children, size = 'default', id, className }: FormErrorProps) {
  if (children == null || children === false || children === '') return null
  return (
    <p
      id={id}
      role="alert"
      className={cn('flex items-start gap-1.5 text-danger-ink', size === 'sm' ? 'text-small' : 'text-sm', className)}
    >
      <AlertCircle aria-hidden className={cn('shrink-0', size === 'sm' ? 'mt-px h-3.5 w-3.5' : 'mt-0.5 h-4 w-4')} />
      <span className="min-w-0">{children}</span>
    </p>
  )
}
